<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 财务管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>记账对账</el-breadcrumb-item>
				<el-breadcrumb-item>记账簿</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-select v-model="query.reportConfigId" placeholder="记账类型">
					<el-option key="" label="请选择" value=""></el-option>
					<el-option v-for="item in reportConfigKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
                <el-date-picker
						type="month"
						placeholder="期号"
						v-model="query.period"
						value-format="yyyy-MM"
						v-if="query.reportConfigId==0"
				></el-date-picker>
				<el-date-picker
						type="year"
						placeholder="年份"
						v-model="query.period"
						value-format="yyyy"
						v-if="query.reportConfigId>0"
				></el-date-picker>
				<el-form-item label="季度" prop="quarter" v-if="query.reportConfigId==1">
					<el-select v-model="query.quarter" placeholder="请选择季度">
						<el-option key="" label="请选择" value=""></el-option>
						<el-option key="1" label="第一季度" value="1"></el-option>
						<el-option key="2" label="第二季度" value="2"></el-option>
						<el-option key="3" label="第三季度" value="3"></el-option>
						<el-option key="4" label="第四季度" value="4"></el-option>
					</el-select>
				</el-form-item>&nbsp;
				<el-select v-model="query.status" placeholder="状态">
					<el-option key="" label="请选择" value=""></el-option>
					<el-option v-for="item in statusKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
				</el-select>&nbsp;
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column prop="period" label="期号">
					<template slot-scope="scope">
						{{scope.row.period}}{{scope.row.quarter?("-Q"+scope.row.quarter):""}}
					</template>
				</el-table-column>
                <el-table-column prop="reportConfigId" label="记账类型" :formatter="reportConfigFormat"></el-table-column>
				<el-table-column prop="startDate" label="日期段" width="360">
					<template slot-scope="scope">
						{{scope.row.startDate}} 至 {{scope.row.endDate}}
					</template>
				</el-table-column>
				<el-table-column prop="status" label="状态" :formatter="statusFormat"></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            icon="el-icon-view"
                            @click="handleShow(scope.$index, scope.row)"
							v-if="controll['show']"
                        >详情</el-button>
						<el-button
                            type="text"
                            icon="el-icon-printer"
                            @click="handleExport(scope.$index, scope.row)"
							v-if="controll['export']"
                        >导出</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(scope.$index, scope.row)"
							v-if="controll['delete']"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
			<div class="record-a-d">
				<el-button
                    type="primary"
                    icon="el-icon-lx-add"
                    class="handle-del mr10"
                    @click="handleAdd"
					v-if="controll['add']"
                >构建报表</el-button>
			</div>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="40%">
            <el-form ref="form" :model="form" label-width="100px" :rules="rules">
				<el-form-item label="记账类型" prop="reportConfigId">
					<el-select v-model="form.reportConfigId" placeholder="请选择记账类型">
						<el-option key="" label="请选择" value=""></el-option>
						<el-option v-for="item in reportConfigKV" :key="item.key" :label="item.value" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="期号" prop="period" v-if="form.reportConfigId!=undefiend">
					<el-date-picker
							type="month"
							placeholder="年月"
							v-model="form.period"
							value-format="yyyy-MM"
							v-if="form.reportConfigId==0 || form.reportConfigId == 5"
					></el-date-picker>
					<el-date-picker
							type="year"
							placeholder="年份"
							v-model="form.period"
							value-format="yyyy"
							v-if="form.reportConfigId==1 || form.reportConfigId == 2"
					></el-date-picker>&nbsp;
				</el-form-item>
				<el-form-item label="季度" prop="quarter" v-if="form.reportConfigId==1">
					<el-select v-model="form.quarter" placeholder="请选择季度">
						<el-option key="" label="请选择" value=""></el-option>
						<el-option key="1" label="第一季度" value="1"></el-option>
						<el-option key="2" label="第二季度" value="2"></el-option>
						<el-option key="3" label="第三季度" value="3"></el-option>
						<el-option key="4" label="第四季度" value="4"></el-option>
					</el-select>&nbsp;
				</el-form-item>
                <el-form-item label="备注">
					<el-input type=textarea :rows=5 v-model="form.remark"> </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit" v-prevent-re-click>确 定</el-button>
            </span>
        </el-dialog>
		
		<el-dialog v-dialogDrag :close-on-click-modal=false title="流程确认" :visible.sync="promptVisible" width="40%">
			<el-alert title="1. 确认资金流水导入完整，企税银三方对账完成！" type="warning" show-icon :closable="false"></el-alert>
			<el-alert title="2. 确认进项票全部导入完成，抵扣同步确认完成！" type="warning" show-icon :closable="false"></el-alert>
			<el-alert title="3. 确认报销票据(成本管理)导入/录入，发放状态同步完成！" type="warning" show-icon :closable="false"></el-alert>
			<el-alert title="4. 确认工资单录入，复核，发放状态同步完成！" type="warning" show-icon :closable="false"></el-alert>
			<el-alert title="5. 确认资金流水中不明确数据记录在会计调整中调整完成！" type="warning" show-icon :closable="false"></el-alert>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="handleNext" v-prevent-re-click>下一步</el-button>
            </span>
        </el-dialog>
		
		<!-- 详情 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="showVisible" fullscreen>
			<el-descriptions class="margin-top" title="" :column="4" size="medium" labelStyle="width:150px;" border>
				<el-descriptions-item>
					<template slot="label">
						期号
					</template>
					{{show.period}}{{show.quarter?("-Q"+show.quarter):""}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						名称
					</template>
					{{reportConfigFormat(show, null, show.reportConfigId)}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						日期段
					</template>
					{{show.startDate}} 至 {{show.endDate}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						状态
					</template>
					{{statusFormat(show, null, show.status)}}
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						进项票抵扣
					</template>
					<div>税价合计：￥{{show.deductionIncomeAmount}}</div>
					<div>税&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;额：￥{{show.deductionIncomeTax}}</div>
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						成本票抵扣
					</template>
					<div>税价合计：￥{{show.deductionCostAmount}}</div>
					<div>税&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;额：￥{{show.deductionCostTax}}</div>
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						销项票
					</template>
					<div>税价合计：￥{{show.salesAmount}}</div>
					<div>税&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;额：￥{{show.salesTax}}</div>
				</el-descriptions-item>
				<el-descriptions-item>
					<template slot="label">
						应交增值税
					</template>
					￥{{show.taxAmount}}
				</el-descriptions-item>
			</el-descriptions>
			<br/><br/>
            <el-tabs v-model="activeName" type="card">	
				<el-tab-pane label="记账详情" name="bookkeepingTab">
					<div style="text-align:right;padding-bottom:10px;">
						<font color="red">{{bookkeepingErrors>0?"记账薄有" + bookkeepingErrors + "条异常数据":""}}</font>&nbsp;&nbsp;
						<el-input class="handle-input mr10"
							placeholder="输入关键字进行过滤"
							v-model="filterText">
						</el-input>
					</div>
					<el-table
						:data="bookkeepingDatasource.filter(data => !filterText || data.precis.toLowerCase().includes(filterText.toLowerCase()) || data.subject.toLowerCase().includes(filterText.toLowerCase()))"
						row-key="key"
						border
						default-expand-all
						:row-class-name="tableRowClassName"
						:tree-props="{children: 'children', hasChildren: 'hasChildren'}">
						<el-table-column
						  prop="idx"
						  label="凭证号"
						  width="150">
						  <template slot-scope="scope">
							{{scope.row.idx?("记-" + scope.row.idx + "号"):""}}
						  </template>
						</el-table-column>
						<el-table-column
						  prop="precis"
						  label="摘要">
						</el-table-column>
						<el-table-column
						  prop="subject"
						  label="内容/备注">
						  <template slot-scope="scope">
							<font :color="scope.row.leaf?'#606266':(scope.row.status==1?'red':'#606266')">
								{{scope.row.subject}}
							</font>
						</template>
						</el-table-column>
						<el-table-column
						  prop="debit"
						  label="借方金额"
						  width="150">
						</el-table-column>
						<el-table-column
						  prop="credit"
						  label="贷方金额"
						  width="150">
						</el-table-column>
					</el-table>
				</el-tab-pane>
				<el-tab-pane label="记账汇总" name="summaryTab">
					<el-table
						:data="summaryData"
						border
						class="table"
						ref="multipleTable"
						header-cell-class-name="table-header"
						:cell-style="{padding:4+'px'}"
						stripe
					>
						<el-table-column prop="accountingCode" label="科目编码"></el-table-column>
						<el-table-column prop="accountingName" label="科目名称"></el-table-column>
						<el-table-column prop="debit" label="借方金额">
						<template slot-scope="scope">
							{{scope.row.debit == 0?"":scope.row.debit}}
						</template>
						</el-table-column>
						<el-table-column prop="credit" label="贷方金额">
						<template slot-scope="scope">
							{{scope.row.credit == 0?"":scope.row.credit}}
						</template>
						</el-table-column>
					</el-table>
				</el-tab-pane>
				<el-tab-pane label="职工薪酬" name="salaryTab">
					<el-table
						:data="salaryData"
						border
						class="table"
						ref="multipleTable"
						header-cell-class-name="table-header"
						:cell-style="{padding:4+'px'}"
						stripe>
						<el-table-column prop="recordType" label="薪酬类型" width="150">
							<template slot-scope="scope">
								{{scope.row.recordType==0?"工资":(scope.row.recordType==1?"年终奖":"其他")}}
							</template>
						</el-table-column>
						<el-table-column prop="name" label="姓名" width="150"></el-table-column>
						<el-table-column prop="salaryPayable" label="本期收入" width="150">
							<template slot-scope="scope">
								{{scope.row.personalIncomeTax + scope.row.salaryPayable}}
							</template>
						</el-table-column>
						<el-table-column label="本期专项扣除" align="center">
							<el-table-column prop="retirementInsurance" label="养老保险">
							</el-table-column>
							<el-table-column prop="medicalTreatmentInsurance" label="医疗保险">
							</el-table-column>
							<el-table-column prop="unemploymentInsurance" label="失业保险">
							</el-table-column>
							<el-table-column prop="industrialInjuryInsurance" label="工伤保险">
							</el-table-column>
							<el-table-column prop="birthInsurance" label="生育保险">
							</el-table-column>
							<el-table-column prop="accumulationFund" label="住房公积金">
							</el-table-column>
							<el-table-column prop="summary" label="合计">
								<template slot-scope="scope">
									{{((scope.row.retirementInsurance?scope.row.retirementInsurance:0) 
									 +(scope.row.medicalTreatmentInsurance?scope.row.medicalTreatmentInsurance:0)
									 +(scope.row.unemploymentInsurance?scope.row.unemploymentInsurance:0)
									 +(scope.row.industrialInjuryInsurance?scope.row.industrialInjuryInsurance:0)
									 +(scope.row.birthInsurance?scope.row.birthInsurance:0)
									 +(scope.row.accumulationFund?scope.row.accumulationFund:0)).toFixed(2)}}
								</template>
							</el-table-column>
						</el-table-column>
						<el-table-column prop="personalIncomeTax" label="应补(退)税额">
						</el-table-column>
						<el-table-column prop="salaryPayable" label="应发工资">
						</el-table-column>
					</el-table>
				</el-tab-pane>
				<el-tab-pane label="报销凭证" name="reimburseTab">
					<el-table
						:data="reimburseData"
						border
						class="table"
						ref="multipleTable"
						header-cell-class-name="table-header"
						:span-method="mergeRow"
						:cell-style="{padding:4+'px'}"
						stripe>
						<el-table-column prop="title" label="标题" width="350px"></el-table-column>
						<el-table-column prop="itemDate" label="报销日期" width="150px"></el-table-column>
						<el-table-column prop="total" label="报销总金额" width="150px"></el-table-column>
						<el-table-column prop="documentNum"	label="报销单据数量" width="150px"></el-table-column>
						<el-table-column label="分类合计详情" align="center">
							<el-table-column prop="reimburseSubType" label="用途"></el-table-column>
							<el-table-column prop="amount"	label="金额"></el-table-column>
						</el-table-column>
					</el-table>
				</el-tab-pane>
			</el-tabs>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchAccountingReportData, saveAccountingReport, deleteAccountingReport, getAccountingReport, 
getAccountingReportConfigKV, exportAccountingReportById } from '../../../api/index';
export default {
    name: 'accounting-report',
    data() {
		let checkNum = (rule, value, callback) => {
			const mailReg = /^[0-9]*$/
			if (value) {
				if (mailReg.test(value)) {
					callback()
				} else {
					callback(new Error('编码为数值型'));
				}
			} else {
				callback(new Error('请输入编码'));
			}
		}
        return {
            query: {
                code: '',
                name: '',
                pageNum: 1,
                pageSize: 10
            },
			reportConfigKV:[],
            tableData: [],
            delList: [],
            editVisible: false,
            pageTotal: 0,
            form: {},
			show: {},
            idx: -1,
            id: -1,
			title:"",
			showVisible:false,
			bookkeepingCode:"5",
			bookkeepingErrors:0,
			bookkeepingDatasource:[],
			salaryData:[],
			summaryData:[],
			reimburseData:[],
			reportMonth:0,
			reportQuarter:1,
			reportYear:2,
			filterText:"",
			rules: {
                reportConfigId: [{ required: true, message: '请选择报表类型', trigger: 'blur' }],
				period: [{ required: true, message: '请选择期号', trigger: 'blur' }],
				quarter: [{ required: true, message: '请选择季度', trigger: 'blur' }],
            },
			controll:{},
			statusKV:[{"key":0, "value":"待生成"}, {"key":1, "value":"生成中"}, {"key":2, "value":"已生成"}, {"key":3, "value":"生成失败"}],
			monthVisible:false,
			activeName:"",
			promptVisible:false
        };
    },
    created() {
		this.controll = getControll("accounting-report");
		this.getConfigKV();
        this.getData();
    },
    methods: {
        // 获取财务报表数据
        getData() {
            fetchAccountingReportData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error(res.message);
				}
            });
        },
		//获取财务报表类型
		getConfigKV() {
			getAccountingReportConfigKV().then(res=>{
				if (res.code == 0 ) {
					this.reportConfigKV = res.data;
				} else {
					this.$message.error(res.message);
				}
			});
		},
		statusFormat(row, column, cellValue){
			let index = this.statusKV.findIndex(item => {
				if (item.key === cellValue) {
					return true;
				}
			});
			if (index === -1) return cellValue;
			return this.statusKV[index].value;
		},
		reportConfigFormat(row, column, cellValue){
			let index = this.reportConfigKV.findIndex(item => {
				if (item.key === cellValue) {
					return true;
				}
			});
			if (index === -1) return cellValue;
			return (row.quarter?("Q"+row.quarter):"") + this.reportConfigKV[index].value;
		},
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
					deleteAccountingReport([row.id]).then(res => {
						if (res.code == 0) {
							this.$message.success('删除成功');
							this.getData();
						} else {
							this.$message.error(`删除失败！` + res.message);
						}
					});
                })
                .catch(() => {});
        },
		//添加操作
		handleAdd() {
			this.promptVisible = true;
		},
		handleNext() {
			this.promptVisible = false;
			this.form = {};
			this.title = "添加新纪录";
			this.editVisible = true;
		},
        // 编辑操作
        handleShow(index, row) {
			getAccountingReport(row.id).then(res => {
				if (res.code == 0) {
					this.title = "详情";
					//this.reportConfigFormat(row, null, row.reportConfigId);
					this.show = res.data;
					this.bookkeepingDatasource = this.show.items;
					this.bookkeepingErrors = this.show.errors;
					this.summaryData = this.show.summaryData;
					this.salaryData = this.show.salarys;
					this.reimburseData = this.show.reimburses;
					this.showVisible = true;
					this.activeName="bookkeepingTab";
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
        },
		// 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					saveAccountingReport(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							this.getData();
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
        // 导出报表
        handleExport(index, row){
			exportAccountingReportById(row.id).then(res => {
				if (res.code == 0) {
					this.$router.push({path: "export-bookkeeping", query:{code:5, key: res.data}});
				} else {
					this.$message.error(`导出报表失败！` + res.message);
				}
			});
		},
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		//颜色控制
		tableRowClassName({row, rowIndex}) {
			if (!row.leaf) {
			  return 'warning-row';
			} 
			return '';
        },
		//合并行
		mergeRow({ row, column, rowIndex, columnIndex }) {
			for (var i = 0; i < 4; i++) {
				if (columnIndex === i) {
					if (row.itemCount === 0) {
						return {
							rowspan: 0,
							colspan: 0
						};
					} else {						
						return {
							rowspan: row.itemCount,
							colspan: 1
						};
					}
				}
			}
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}

/deep/ .el-table .warning-row {
	background: #fafafa;
	font-size:14px;
}

</style>
